export class RequestColumn {
    Name: string;
    IsCommaSeparated: boolean;
}